/**
 * Labstep
 *
 * @module components/PurchaseOrder/Form/ShowEdit/Handling
 * @desc ShowEdit form for order request currency and handling
 */

import { fieldPurchaseOrderHandlingAmount } from 'labstep-web/components/PurchaseOrder/Form/fields';
import { FormShowEditAmount as ShowEditAmount } from 'labstep-web/core/Form/ShowEdit/Amount';
import type React from 'react';
import type { IPurchaseOrderFormShowEditHandlingProps } from './types';

export const PurchaseOrderFormShowEditHandling: React.FC<
  IPurchaseOrderFormShowEditHandlingProps
> = ({ purchaseOrder }) => (
  <ShowEditAmount
    entity={purchaseOrder}
    entityName={purchaseOrder.entityName}
    field={fieldPurchaseOrderHandlingAmount}
    currency={purchaseOrder.currency}
  >
    {purchaseOrder.printHandling}
  </ShowEditAmount>
);
